export default __webpack_public_path__ + "static/media/hashpackIcon.60eb92a0.svg";